<div class="flex flex-col gap-2">
    <div class="flex flex-col">
        <span>{{ 'document.current-status' | translate }}:</span>
        <div class="flex items-center gap-2">
            <app-widget-document-status-icon
                [documentStatus]="documentLineItem().status"
                [dataTestId]="'document-line-item-status-icon'"
            />
            <b> {{ 'enums.' + documentLineItem().status | translate }} </b>
        </div>
    </div>
    <div class="flex flex-col">
        <span>{{ 'document.new-status' | translate }}:</span>
        <app-generic-enum-drop-down
            [(ngModel)]="newStatus"
            [enumName]="'DocumentStatusType'"
            [itemTemplate]="itemTemplate"
            [selectItemTemplate]="itemTemplate"
            [dataTestId]="'document-line-item-status-dropdown'"
            (valueChange)="newStatus.set($event)"
        />
        <ng-template #itemTemplate let-item>
            <app-widget-document-status-icon [documentStatus]="item.key" />
            {{ item?.val }}
        </ng-template>
    </div>
    <p-button
        class="mt-2"
        [disabled]="btnIsDisabled()"
        icon="fa fa-check"
        label="{{ 'common.confirm' | translate }}"
        styleClass="w-full"
        (onClick)="confirm()"
        [attr.data-testid]="'document-status-confirm-button'"
    />
</div>
